import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.975 5h-9.6l3.3-3.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0l-5 5c-.1.1-.2.2-.2.3-.1.3-.1.5 0 .8.1.1.1.2.2.3l5 5c.2.2.4.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L3.375 7h9.6c1.7 0 3 1.3 3 3v7c0 .6.4 1 1 1s1-.4 1-1v-7c0-2.8-2.2-5-5-5"
    }, null, -1)
  ]))]))
}
export default { render: render }